import Utils from './basic.utils' // 工具库

export default {
  install(Vue) {
    Object.defineProperties(Vue.prototype, {
      $utils: {
        get: function get () {
          return Object.assign({},Utils)
        }
      }
    })
  }
}



